import { render } from "./replacement-quotes.vue?vue&type=template&id=1b5f43af"
import script from "./replacement-quotes.vue?vue&type=script&lang=js"
export * from "./replacement-quotes.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__